module.exports = __webpack_public_path__ + "img/sjh_logo.d9a5fb62.png";